import { Component, Input } from '@angular/core';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { UpsellSlugs } from '@enums/upsell-slugs';

@Component({
  selector: 'app-replenish-your-good-bacteria',
  templateUrl: './replenish-your-good-bacteria.component.html',
  imports: [UpsellCardComponent],
})
export class ReplenishYourGoodBacteriaComponent {
  @Input() public slug: UpsellSlugs = UpsellSlugs.Probiotics;
}
